import { css } from "styled-components";
import { carouselNextPrev2XKO } from "../../../CarouselNext/skins/project-l";
export const riotLionSkin = (chroma, paletteTokens) => css `
  --default-clip-path: path(
    "M5 22 L0 11 L5 0 L18 0 L13 11 L18 22 L23 22 L18 11 L23 0 L36 0 L31 11 L36 22 L41 22 L36 11 L41 0 L54 0 L49 11 L54 22Z"
  );
  --hover-clip-path: path(
    "M5 22 L0 11 L5 0 L18 0 L13 11 L18 22 L18 22 L13 11 L18 0 L36 0 L31 11 L36 22 L36 22 L31 11 L36 0 L54 0 L49 11 L54 22Z"
  );

  ${carouselNextPrev2XKO(chroma, paletteTokens)}
`;
//# sourceMappingURL=index.js.map